// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

export const RingSizeFragmentDoc = `
    fragment ringSize on RingSize {
  __typename
  id
  ringSizeLabel: label(country: $country)
}
    `;